import { CTAColorVariant } from '~/components/shared/CTAButton';
import { WALMART_URLS } from '../../../config/urls';

export const DEFAULT_PROPS = {
  CTAButtonText: 'Claim offer now',
  CTAButtonVariant: 'aa-primary-blue' as CTAColorVariant,
  CTAButtonLink:
    'https://www.walmart.com/?wplusSignupOffer=true&programId=discmemb23',
};

export const STUDENT_PROPS = {
  CTAButtonText: 'Claim your free trial',
  CTAButtonVariant: 'aa-primary-blue' as CTAColorVariant,
  CTAButtonLink: WALMART_URLS.PLUS_STUDENT_SIGNUP,
};
